import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";
import { SnackbarContext } from "./SnackbarContext";
import { RefreshTokenContext } from "./RefreshTokenContext";
import { VARIABLES } from "../Constant";

// const VARIABLES = {
//   url: "https://rms-api-test.techwalnut.co.in",
// };

export const NotificationsContext = createContext(null);

function NotificationsContextProvider({ children }) {
  const userID = secureLocalStorage.getItem("userID");

  const { RefreshToken } = useContext(RefreshTokenContext);

  const [notifications, setNotifications] = useState([]);
  const [allNotifications, setAllNotifications] = useState([]);
  const [readNotifications, setReadNotifications] = useState([]);
  const [unReadNotifications, setUnReadNotifications] = useState([]);
  const [unreadNotificationsCount, setUnreadNotificationsCount] = useState(0);
  const [retryCount, setRetryCount] = useState(0);
  const eventSourceRef = useRef(null);
  const [noPages, setNoPages] = useState(1);
  const [entries, setEntries] = useState(5);
  const [totalEntries, setTotalEntries] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [areNotificationsLoading, setAreNotificationsLoading] = useState(false);
  const [noNotificationsData, setNoNotificationsData] = useState(false);
  const { setSubmitMessage } = useContext(SnackbarContext);

  // Notification mapper Data
  const [isNotificationMapperData, setIsNotificationMapperData] =
    useState(false);
  const [rawNotificationMapper, setRawNotificationMapper] = useState([]);
  const [notificationMapperEntries, setNotificationMapperEntries] = useState(5);
  const [notificationMapperCount, setNotificationMapperCount] = useState(null);
  const [notificationMapperPageCount, setNotificationMapperPageCount] =
    useState(0);
  const [isNotificationMapperLoading, setIsNotificationMapperLoading] =
    useState(true);

  const getNotifications = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${VARIABLES.url}/notifications/api/?is_read=false&user_id=${userID}`,
      headers: {},
    };
    axios
      .request(config)
      .then((response) => {
        setNotifications(response.data.results.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getAllNotifications = (page_no = currentPage, entrie = entries) => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url:
        `${VARIABLES.url}` +
        `/notifications/api/?page=${page_no}&entries=${entrie}&user_id=${userID}`,
      headers: {},
    };
    setAreNotificationsLoading(true);
    axios
      .request(config)
      .then((response) => {
        setNoPages(response.data.num_pages);
        setCurrentPage(response.data.current_page);
        setTotalEntries(response.data.count);
        setAllNotifications(response.data.results.data);
        setNoNotificationsData(
          response.data.results.data.length !== 0 ? false : true
        );
        setAreNotificationsLoading(false);
      })
      .catch((error) => {
        setNoNotificationsData(true);
        setAreNotificationsLoading(false);
        console.log(error);
      });
  };

  const handleNotificationStatus = (id) => {
    setNotifications(
      notifications.map((notification) => {
        if (notification.id === id) return { ...notification, is_read: true };
        return notification;
      })
    );
    if (!readNotifications.includes(id))
      setReadNotifications([...readNotifications, id]);
  };

  const updateNotificationStatus = () => {
    if (unReadNotifications.length !== 0 || readNotifications.length !== 0) {
      let data = "";
      data = JSON.stringify({
        mark_as_read: readNotifications,
        mark_as_unread: unReadNotifications,
      });
      if (data !== "") {
        let config = {
          method: "patch",
          maxBodyLength: Infinity,
          url: `${VARIABLES.url}/notifications/api/`,
          headers: {
            "Content-Type": "application/json",
          },
          data: data,
        };
        axios
          .request(config)
          .then((response) => {
            getNotifications();
            getAllNotifications();
            setUnReadNotifications([]);
            setReadNotifications([]);
            setSubmitMessage({
              type: "success",
              icon: "check",
              message: "Notifications updated successfully!",
            });
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else {
      // setSubmitMessage({
      //   type: "danger",
      //   icon: "cross",
      //   message: "Nothing to update!",
      // });
      console.log("Nothing to update")
    }
  };

  const createConnection = () => {
    if (eventSourceRef.current) {
      eventSourceRef.current.close();
    }

    const sse = new EventSource(
      `${VARIABLES.url}/notifications/?user_id=${userID}`,
      {
        withCredentials: false,
      }
    );

    setRetryCount(0);

    sse.onmessage = (e) => {
      try {
        const data = JSON.parse(e.data);
        setNotifications(
          data.map((e) => {
            return {
              ...e,
              is_read: false,
            };
          })
        );
        getAllNotifications();
      } catch (error) {
        console.error("Error parsing SSE data:", error);
      }
    };
    sse.onerror = () => {
      console.error("Connection error");
      sse.close();
      setRetryCount((prevCount) => prevCount + 1);
      setTimeout(createConnection, 5000);
    };
    eventSourceRef.current = sse;
  };

  const getNotificationMapperData = async (
    page,
    searchNotificationMapper,
    access
  ) => {
    setIsNotificationMapperLoading(true);
    let url;
    if (searchNotificationMapper) {
      url =
        VARIABLES.url +
        `/api/notification/?entries=${notificationMapperEntries}&page=${page}&event=${searchNotificationMapper}`;
    } else {
      url =
        VARIABLES.url +
        `/api/notification/?entries=${notificationMapperEntries}&page=${page}`;
    }

    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: url,
      headers: {
        Authorization: `Bearer ${access}`,
      },
    };

    try {
      const res = await axios(config);
      let response = res.data.data;
      setIsNotificationMapperLoading(false);
      if (response.length !== 0) {
        setIsNotificationMapperData(false);
        setRawNotificationMapper(res.data.data);
      } else {
        setIsNotificationMapperData(true);
        setRawNotificationMapper(res.data.data);
      }
      const total = res.data.count;
      setNotificationMapperCount(total);
      setNotificationMapperPageCount(
        Math.ceil(total / notificationMapperEntries)
      );
    } catch (error) {
      console.log(error);
      setIsNotificationMapperLoading(false);
      if (error?.response?.status === 403) {
        RefreshToken();
        setIsNotificationMapperData(false);
      } else {
        setIsNotificationMapperData(true);
      }
    }
  };

  const handleNotificationMapperClick = async (
    data,
    searchNotificationMapper
  ) => {
    let access = secureLocalStorage.getItem("access");
    let currentPage = data.selected + 1;
    const commentsFormServer = await getNotificationMapperData(
      currentPage,
      searchNotificationMapper,
      access
    );
  };

  // useEffect(() => {
  //   setUnreadNotificationsCount(notifications.length);
  // }, [notifications]);

  // useEffect(() => {
  //   console.log(retryCount);
  //   if (retryCount !== 0) {
  //     // enqueueSnackbar("No connection!", {
  //     //   anchorOrigin: {
  //     //     vertical: "bottom",
  //     //     horizontal: "center",
  //     //   },
  //     //   variant: "error",
  //     //   persist: true,
  //     //   preventDuplicate: true,
  //     // });
  //   } else {
  //     // closeSnackbar();
  //   }
  // }, [retryCount]);

  useEffect(() => {
    createConnection();
    return () => {
      if (eventSourceRef.current) {
        eventSourceRef.current.close();
      }
    };
  }, []);

  // useEffect(() => {
  //   getNotifications();
  //   getAllNotifications();
  // }, []);

  useEffect(() => {
    updateNotificationStatus()
  }, [readNotifications]);

  const value = {
    notifications,
    allNotifications,
    unreadNotificationsCount,
    setNotifications,
    areNotificationsLoading,
    noPages,
    currentPage,
    entries,
    setEntries,
    setCurrentPage,
    handleNotificationStatus,
    updateNotificationStatus,
    getAllNotifications,
    totalEntries,
    readNotifications,
    unReadNotifications,
    setReadNotifications,
    setUnReadNotifications,
    setAllNotifications,
    noNotificationsData,

    rawNotificationMapper,
    getNotificationMapperData,
    notificationMapperEntries,
    notificationMapperPageCount,
    setNotificationMapperEntries,
    notificationMapperCount,
    handleNotificationMapperClick,
    isNotificationMapperData,
    isNotificationMapperLoading,

    getNotifications,
    setUnreadNotificationsCount,
  };

  return (
    <NotificationsContext.Provider value={value}>
      {children}
    </NotificationsContext.Provider>
  );
}

export default NotificationsContextProvider;
